/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_zo as zo,
} from "../../runtime/index.jsx";
export function Paginacion(e) {
  let t = (0, ReactCompiler.c)(20),
    { pagina: n, tamano: r, total: i, onChange: a, cargando: o } = e,
    s = o !== void 0 && o,
    c = Math.max(1, Math.ceil(i / r));
  if (c <= 1) return null;
  let l = s || n === 0,
    u;
  t[0] !== a || t[1] !== n
    ? ((u = () => a(n - 1)), (t[0] = a), (t[1] = n), (t[2] = u))
    : (u = t[2]);
  let d;
  t[3] !== l || t[4] !== u
    ? ((d = (
        <button
          type={`button`}
          className={zo}
          disabled={l}
          onClick={u}
          children={`Anterior`}
        />
      )),
      (t[3] = l),
      (t[4] = u),
      (t[5] = d))
    : (d = t[5]);
  let f = n + 1,
    p;
  t[6] !== c || t[7] !== f || t[8] !== i
    ? ((p = (
        <span children={[`Página `, f, ` de `, c, ` · `, i, ` registros`]} />
      )),
      (t[6] = c),
      (t[7] = f),
      (t[8] = i),
      (t[9] = p))
    : (p = t[9]);
  let m = s || n + 1 >= c,
    h;
  t[10] !== a || t[11] !== n
    ? ((h = () => a(n + 1)), (t[10] = a), (t[11] = n), (t[12] = h))
    : (h = t[12]);
  let _;
  t[13] !== m || t[14] !== h
    ? ((_ = (
        <button
          type={`button`}
          className={zo}
          disabled={m}
          onClick={h}
          children={`Siguiente`}
        />
      )),
      (t[13] = m),
      (t[14] = h),
      (t[15] = _))
    : (_ = t[15]);
  let v;
  return (
    t[16] !== d || t[17] !== p || t[18] !== _
      ? ((v = (
          <nav
            aria-label={`Paginación`}
            className={`flex items-center justify-between gap-3 text-sm text-(--text)`}
            children={[d, p, _]}
          />
        )),
        (t[16] = d),
        (t[17] = p),
        (t[18] = _),
        (t[19] = v))
      : (v = t[19]),
    v
  );
}
